import ReactHtmlParser from "react-html-parser";

export default (sopParameters) => ReactHtmlParser(
  `
   <div>
     <p>There is a tornado warning currently impacting your area. Please shelter in place immediately until the warning has lifted. You will receive another work item when the warning is lifted and you are free to resume normal operations</p>
     <ol>
        <li>Suspend operations immediately</li>
        <li>Direct all onsite personnel to designated Shelter in place locations</li>
        <li>Verify all onsite personnel is accounted for and safe</li>
        <li>Once above actions are confirmed, close out the exception</li>
        <li>Remain in SIP location until the warning has expired</li>
     </ol>
  </div>
   `
);


// WEBPACK FOOTER //
// ./src/components/taskExecution/TaskSOP/FallbackSOPWiki/AMZL_Shelter_In_Place_Tornado_Warning.jsx